export default "/images/tv.svg?9fc05469a54d3fed7c0da17ea5345f2f";